import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ModePage } from '../types/common/ConfigPageComponent';
import { components } from '../../navigation';

import SuspenseLazy from '../../../ui/SuspenseLazy';

import Welcome from './Welcome';
import AccessDenied from './AccessDenied';
import NotFound from './NotFound';
import Security from '../../Security';

import { loadRoles, loadUser } from '../../users/ducks/user';
import { useDispatch } from 'react-redux';
import LogoutPageRedirect from './LogoutPageRedirect';
import api from '../../../libs/api';
// import RedirectToRedesignApp from '../../Toetsing/components/RedirectToRedesignApp/RedirectToRedesignApp';

// Pages

const Drainage = React.lazy(() => import('../../Drainage'));
const Licenses = React.lazy(() => import('../../Licenses'));

const AsiteRelatics = React.lazy(() => import('../../asite-relatics'));
const FastDraftRelatics = React.lazy(() => import('../../fastdraft-relatics'));
const ProductReservation = React.lazy(() => import('../../ProductReservation'));

const { Navbar } = components;

const Root = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadUser());
        dispatch(loadRoles());
    }, []);

    return (
        <Grid className="App">
            <Navbar />
            <Switch>
                <Route path="/asite-relatics">
                    <SuspenseLazy>
                        <AsiteRelatics link={'asite-relatics'} showHeader={true} modePage={ModePage.BaseComponent} />
                    </SuspenseLazy>
                </Route>
                <Route path="/fastdraft-relatics">
                    <SuspenseLazy>
                        <FastDraftRelatics link={'fastdraft-relatics'} showHeader={true} modePage={ModePage.BaseComponent} />
                    </SuspenseLazy>
                </Route>

                <Route path="/welcome">
                    <Welcome />
                </Route>
                <Route path="/access-denied">
                    <AccessDenied />
                </Route>
                <Route path="/licenses">
                    <SuspenseLazy>
                        <Licenses link={'licenses'} showHeader={true} modePage={ModePage.BaseComponent} />
                    </SuspenseLazy>
                </Route>
                <Route path="/drainage">
                    <SuspenseLazy>
                        <Drainage link={'drainage'} showHeader={true} modePage={ModePage.BaseComponent} />
                    </SuspenseLazy>
                </Route>
                <Route path="/security">
                    <Security link={'security'} showHeader={true} modePage={ModePage.BaseComponent} />
                </Route>
                <Route path="/product-reservation">
                    <SuspenseLazy>
                        <ProductReservation
                            link={'product-reservation'}
                            showHeader={true}
                            modePage={ModePage.BaseComponent}
                        />
                    </SuspenseLazy>
                </Route>
                <Route path="/access-denied">
                    <AccessDenied />
                </Route>
                <Route path="/logout">
                    <LogoutPageRedirect />
                </Route>

                <Route path="*">
                    <NotFound />
                </Route>
            </Switch>
        </Grid>
    );
};

export default Root;
